import { createSvg } from '../createSvg';

const Wifi = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return <>
        <g id={'contour'}>
            <path d='M4.90991 11.84C9.20991 8.52001 14.7999 8.52001 19.0999 11.84' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M2 8.35998C8.06 3.67998 15.94 3.67998 22 8.35998' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M6.79004 15.49C9.94004 13.05 14.05 13.05 17.2 15.49' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M9.3999 19.15C10.9799 17.93 13.0299 17.93 14.6099 19.15' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        </g>
    </>;
};

export default createSvg(
    Wifi,
    'wifi',
);
